/*
* Configuration for Cart
*/
export default function () {
  const { $i18n: i18n } = useNuxtApp()

  return {
    cartEnable: false,
    cardFeeDescr: i18n?.t('cardFeeDescr'),
    cartActions: {
      blockParentClasses: 'bordered-box'
    }
  }
}
